var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLOverLeagueApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 405",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,404.7V376h5.6v23.7h13v5H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,404.7V376h18.9v5H32.6v6.8h11.3v5H32.6v7h13.3v5L27,404.7L27,404.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6,404.7l-1.7-5.1H60.7l-1.7,5.1h-6L63.5,376h4.4l10.5,28.7H72.6z M65.9,384.4l-3.7,10.4h7.1L65.9,384.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.7,401.7c-2.2,2.2-4.9,3.3-8.1,3.3c-3.1,0-5.6-1.1-7.7-3.2c-1.3-1.3-2-2.7-2.3-4.3c-0.3-1.6-0.5-4-0.5-7.1 s0.2-5.5,0.5-7.1s1.1-3.1,2.3-4.3c2.1-2.1,4.6-3.2,7.7-3.2c6.6,0,10,4.2,10.8,9.2h-5.6c-0.7-2.8-2.4-4.2-5.1-4.2 c-1.4,0-2.7,0.5-3.6,1.5c-1.1,1.4-1.4,2.4-1.4,8s0.3,6.8,1.4,8.1c0.9,1,2,1.4,3.6,1.4s3-0.5,4-1.6c0.9-1,1.3-2.2,1.3-3.9v-1.1h-5.3 v-4.6h10.8v4.2C105.4,397.1,104.6,399.6,102.7,401.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.6,404.9c-5.9,0-10.5-4-10.5-10V376h5.6v18.6c0,3.3,1.9,5.3,4.9,5.3s5-1.9,5-5.3V376h5.6v18.8 C135.2,400.9,130.5,404.9,124.6,404.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145,404.7V376h18.9v5h-13.3v6.8H162v5h-11.3v7h13.2v5L145,404.7L145,404.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.7,404.7l-1.7-5.1h-10.2l-1.7,5.1h-5.9l10.4-28.7h4.3l10.5,28.7H190.7z M184.1,384.4l-3.7,10.4h7.1L184.1,384.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.6,393.9h-5.5v10.8h-5.6V376h11.1c5.9,0,9.5,4.1,9.5,9C225,389.9,221.4,393.9,215.6,393.9z M215.3,380.9h-5.2v7.8h5.2 c2.5,0,4.2-1.5,4.2-3.9C219.4,382.6,217.8,380.9,215.3,380.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.7,393.9h-5.5v10.8h-5.6V376h11.1c5.9,0,9.5,4.1,9.5,9C253.1,389.9,249.7,393.9,243.7,393.9z M243.4,380.9h-5.2v7.8h5.2 c2.5,0,4.2-1.5,4.2-3.9C247.5,382.6,246,380.9,243.4,380.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.1,404.9c-4.3,0-7.6-1-10.5-3.8l3.7-3.7c1.8,1.8,4.3,2.4,7,2.4c3.3,0,5.1-1.3,5.1-3.6c0-1-0.3-1.8-0.9-2.4 c-0.6-0.5-1.3-0.8-2.5-1l-3.5-0.5c-2.4-0.4-4.3-1.2-5.6-2.4c-1.4-1.4-2-3.2-2-5.6c0-5.1,3.8-8.7,10-8.7c4,0,6.9,1,9.3,3.4l-3.6,3.5 c-1.8-1.7-4-1.9-5.9-1.9c-3,0-4.4,1.6-4.4,3.7c0,0.8,0.3,1.4,0.9,2c0.6,0.5,1.4,1,2.7,1.2l3.4,0.5c2.6,0.4,4.3,1.1,5.5,2.2 c1.5,1.4,2.2,3.6,2.2,6.1C279.7,401.8,275.1,404.9,269.1,404.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.4,
    width: 139,
    height: 22.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "254.9,324.5 0,324.5 0,347.4 277.9,347.4 277.9,231.6 254.9,231.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.4,69.2 208.4,46.3 155.6,46.3 73.9,300.9 231.3,300.9 231.3,231.6 208.4,231.6 208.4,277.9 106,277.9 172,69.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0,277.9 0,300.9 49.8,300.9 131.4,46.3 69.4,46.3 69.4,69.2 99.3,69.2 33.3,277.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLOverLeagueApps);
export default __webpack_public_path__ + "static/media/L_Over_LeagueApps.2b2d4f50633738179b094d7855a939fe.svg";
export { ForwardRef as ReactComponent };